
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  return (
    <div className={`bg-crop-white border border-crop-teal/20 rounded-2xl p-6 ${hover ? 'transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-crop-teal/40' : ''} ${className}`}>
      {children}
    </div>
  );
}
